import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

const fmtMonth = (m) => new Date(`${m}-01T00:00:00Z`).toLocaleDateString("fr-FR", { month: "short", year: "2-digit" });

export const RevenueChart = ({ data, series, title = "Évolution des revenus (12 derniers mois)", testId }) => {
  if (!data || data.length === 0) return null;
  return (
    <div className="bg-white border border-ink/10 rounded-md p-5" data-testid={testId}>
      <p className="text-label text-muted-foreground mb-4">{title}</p>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={data} margin={{ top: 4, right: 8, left: -8, bottom: 0 }}>
          <defs>
            {series.map((s) => (
              <linearGradient key={s.key} id={`grad-${s.key}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={s.color} stopOpacity={0.22} />
                <stop offset="100%" stopColor={s.color} stopOpacity={0} />
              </linearGradient>
            ))}
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(24,24,26,0.06)" vertical={false} />
          <XAxis dataKey="month" tickFormatter={fmtMonth} tick={{ fontSize: 11, fill: "rgba(24,24,26,0.5)" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "rgba(24,24,26,0.5)" }} axisLine={false} tickLine={false} tickFormatter={(v) => `${v}€`} width={56} />
          <Tooltip
            formatter={(v, n) => [`${Number(v).toFixed(2)}€`, n]}
            labelFormatter={fmtMonth}
            contentStyle={{ borderRadius: 6, border: "1px solid rgba(24,24,26,0.1)", fontSize: 12 }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {series.map((s) => (
            <Area key={s.key} type="monotone" dataKey={s.key} name={s.name} stroke={s.color} strokeWidth={2} fill={`url(#grad-${s.key})`} dot={false} />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueChart;
